import { Component } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

export default class Item extends Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    onClick: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
  };

  handleClicked = e => {
    this.props.onClick(this.props.value, this.props.index);
    e.stopPropagation();
  };

  renderMessage() {
    const { value } = this.props;

    switch (typeof value) {
      case "object":
        return <FormattedMessage {...value} />;
      case "string":
      default:
        return value;
    }
  }

  render() {
    return (
      <ItemContainer onClick={this.handleClicked}>
        {this.renderMessage()}
      </ItemContainer>
    );
  }
}

const ItemContainer = styled.div`
  background-color: white;
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.hoverColor};
  }
`;
